export default __webpack_public_path__ + "static/media/Ideate_3.5ccbc0f6.jpg";